import React from "react";
import { Link } from "react-router-dom";

import { cn } from "../../../common/u1/cn";
import { BuildingIcon } from "../../../../assets/ui/icons";

/* The Partner Program, for a company that is not a member.
 *
 * Hiding the rail item is not a gate — the route is still typeable, and a
 * bookmark from a lapsed membership still resolves. This is what
 * /dashboard/enterprise renders instead.
 *
 * It says what the screen is and how to reach it rather than turning the
 * viewer away: the same shape the Counterparty Briefs claim gate takes
 * (ClaimGate, TIP-609), which sits in front of that product rather than
 * redirecting out of it. Redirecting would also lose the one useful fact —
 * that this exists and membership is what opens it.
 *
 * `/dashboard/membership` is the rail's own Membership destination, not the
 * public /membership page: the viewer is already inside the dashboard.
 */
export const PartnerProgramGate = ({ companyName = "", className = "" }) => (
  <section
    className={cn(
      "rounded-[18px] border border-[var(--line)] bg-white p-8 text-center sm:p-10",
      "shadow-[0_1px_2px_rgba(20,40,60,.03)]",
      className
    )}
  >
    <span
      aria-hidden="true"
      className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-[var(--coral-soft)] text-[var(--coral)]"
    >
      <BuildingIcon size={26} />
    </span>

    <h2 className="m-0 text-[20px] font-bold text-[var(--ink)] font-sans">
      The Partner Program is a Member benefit
    </h2>

    <p className="mx-auto mt-2 mb-0 max-w-[560px] text-[14px] leading-[1.6] text-[var(--ink-2)] font-sans">
      Track your buyers in one place: upload your customer lists and TREVEX handles profile
      creation, verification and credibility boosting, with real-time monitoring and instant
      updates.
    </p>

    {/* Membership is per company, so which one is being judged is not a
        detail the viewer can be left to guess — they may have several. */}
    <p className="mx-auto mt-3 mb-0 max-w-[560px] text-[13.5px] leading-[1.6] text-[var(--muted)] font-sans">
      {companyName ? (
        <>
          <b className="font-semibold text-[var(--ink-2)]">{companyName}</b> does not have an
          active membership yet.
        </>
      ) : (
        "It opens once the business you are acting as has an active membership."
      )}
    </p>

    <Link
      to="/dashboard/membership"
      className={cn(
        "mt-6 inline-flex h-[46px] items-center justify-center rounded-xl px-6",
        "bg-[var(--coral)] text-[15px] font-bold text-white font-sans transition-colors",
        "hover:bg-[var(--coral-deep)] focus-visible:outline-none focus-visible:ring-2",
        "focus-visible:ring-[var(--orange)] focus-visible:ring-offset-2"
      )}
    >
      Become a Member
    </Link>
  </section>
);

export default PartnerProgramGate;
